import React from 'react';

interface SkeletonProps {
  className?: string;
  variant?: 'rectangular' | 'circular' | 'text';
}

export const Skeleton: React.FC<SkeletonProps> = ({ className = '', variant = 'rectangular' }) => {
  const baseClasses = "animate-shimmer bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:1000px_100%]";
  
  const variantClasses = {
    rectangular: "rounded-lg",
    circular: "rounded-full",
    text: "rounded h-4"
  };

  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`} />
  );
};

export const ProductCardSkeleton: React.FC = () => (
  <div className="bg-white rounded-2xl p-4 shadow-card border border-gray-100 flex gap-4 h-full">
    <div className="flex-1 space-y-3 py-1">
      <Skeleton variant="text" className="w-3/4 h-6" />
      <Skeleton variant="text" className="w-full h-4" />
      <Skeleton variant="text" className="w-2/3 h-4" />
      <div className="pt-2">
         <Skeleton variant="text" className="w-20 h-6" />
      </div>
    </div>
    <Skeleton className="w-28 h-28 rounded-xl flex-shrink-0" />
  </div>
);

export const MenuSkeleton: React.FC = () => (
  <div className="space-y-6">
    <div className="h-64 rounded-3xl overflow-hidden relative">
       <Skeleton className="w-full h-full" />
    </div>
    <div className="flex gap-3 overflow-hidden">
       {[1,2,3,4].map(i => <Skeleton key={i} className="w-24 h-10 rounded-full flex-shrink-0" />)}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
       {[1,2,3,4,5,6].map(i => <ProductCardSkeleton key={i} />)}
    </div>
  </div>
);